/**
 * @generated SignedSource<<50f5210afdc62bb240c9321647b01cad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateCustomFieldDefinitionInput = {
  id?: string | null;
  displayName?: string | null;
  readOnly?: boolean | null;
  avaRef?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateCustomFieldDefinitionMutation$variables = {
  input: UpdateCustomFieldDefinitionInput;
};
export type UpdateCustomFieldDefinitionMutation$data = {
  readonly updateCustomFieldDefinition: {
    readonly customFieldDefinition: {
      readonly node: {
        readonly id: string;
        readonly key: string | null;
        readonly type: string | null;
        readonly displayName: string | null;
        readonly readOnly: boolean | null;
        readonly entityType: string | null;
        readonly avaRef: number | null;
      } | null;
    } | null;
  } | null;
};
export type UpdateCustomFieldDefinitionMutation$rawResponse = {
  readonly updateCustomFieldDefinition: {
    readonly customFieldDefinition: {
      readonly node: {
        readonly id: string;
        readonly key: string | null;
        readonly type: string | null;
        readonly displayName: string | null;
        readonly readOnly: boolean | null;
        readonly entityType: string | null;
        readonly avaRef: number | null;
      } | null;
    } | null;
  } | null;
};
export type UpdateCustomFieldDefinitionMutation = {
  variables: UpdateCustomFieldDefinitionMutation$variables;
  response: UpdateCustomFieldDefinitionMutation$data;
  rawResponse: UpdateCustomFieldDefinitionMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCustomFieldDefinitionPayload",
    "kind": "LinkedField",
    "name": "updateCustomFieldDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomFieldDefinitionTypeEdge",
        "kind": "LinkedField",
        "name": "customFieldDefinition",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomFieldDefinition",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "readOnly",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avaRef",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6a1654335f956ad34daff16637d4f2eb",
    "id": null,
    "metadata": {},
    "name": "UpdateCustomFieldDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateCustomFieldDefinitionMutation(\n  $input: UpdateCustomFieldDefinitionInput!\n) {\n  updateCustomFieldDefinition(input: $input) {\n    customFieldDefinition {\n      node {\n        id\n        key\n        type\n        displayName\n        readOnly\n        entityType\n        avaRef\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d4f004eb495d60516952db0b55d5b308";

export default node;
